module.exports = __webpack_public_path__ + "00_hair.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/00_hair.png
// module id = jj7z
// module chunks = 0